export const Loading = () => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 z-[1500] flex justify-center items-center w-full h-full">
      <img src="/img/imc_logo.png" className="z-[1600] animate-pulse w-64" />
    </div>
  );
};
